// extracted by mini-css-extract-plugin
export default {"root":"Buy__root--1C74T","content":"Buy__content--20aei","title":"Buy__title--2_XkB"};